/** Largest integer px in [min, max] for which `fits` is true. `fits(min)` may be false. */
export function fitFontPx(fits, min = 8, max = 800) {
    let lo = min;
    let hi = max;
    let best = min;
    while (lo <= hi) {
        const mid = (lo + hi) >> 1;
        if (fits(mid)) {
            best = mid;
            lo = mid + 1;
        } else {
            hi = mid - 1;
        }
    }
    return best;
}
